import { getPlayersSearchOptions } from "@aura-frontend/omnibus-az-client";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { useAppContext } from "@/hooks/use-app-context";

export const usePlayers = (selectedTeam: string) => {
  const { orgId } = useAppContext();
  const { data, isLoading } = useQuery({
    ...getPlayersSearchOptions({
      query: {
        teamId: selectedTeam,
        visibilityGroup: orgId!,
      },
    }),
    enabled: !!orgId,
  });

  const players = useMemo(() => {
    return (
      data?.players?.map((player) => ({
        id: player.external_ids?.[0],
        name: player.known_names?.[0],
        pitch_side: player.pitch_side,
        hit_side: player.hit_side,
      })) || []
    );
  }, [data]);

  return { players: players ?? [], isLoading };
};
